import { render, staticRenderFns } from "./ParkDetail.vue?vue&type=template&id=23f99cda&scoped=true&"
import script from "./ParkDetail.vue?vue&type=script&lang=ts&"
export * from "./ParkDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ParkDetail.vue?vue&type=style&index=0&id=23f99cda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f99cda",
  null
  
)

export default component.exports